import { render, staticRenderFns } from "./PayTypePopup.vue?vue&type=template&id=20eb90f3&scoped=true"
import script from "./PayTypePopup.vue?vue&type=script&lang=js"
export * from "./PayTypePopup.vue?vue&type=script&lang=js"
import style0 from "./PayTypePopup.vue?vue&type=style&index=0&id=20eb90f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb90f3",
  null
  
)

export default component.exports